





















import { Component, Vue } from "vue-property-decorator";
import VueApexCharts from "vue-apexcharts";

@Component({
  components: {
    apexchart: VueApexCharts,
  },
})
export default class ResidualValueCard extends Vue {
  chipToggle = 1;

  options: any = {
    chart: {
      id: "vuechart-example",
    },
    colors: ["#00c12a"],
    markers: {
      strokeWidth: 0,
      size: 9,
    },
    stroke: {
      dashArray: [0, 4],
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number | null, opts: any) =>
        this.formatCurrency(val, opts),
      style: {
        fontFamily: "Toyota Type",
        fontSize: "18",
        fontWeight: "bold",
      },
      offsetY: -18,
      background: {
        enabled: true,
        foreColor: "#fff",
        borderRadius: 5,
        padding: 20,
        opacity: 0.9,
        borderWidth: 0,
        dropShadow: {
          enabled: true,
          left: 0,
          top: 2,
          opacity: 0.2,
        },
      },
    },
    grid: {
      show: true,
      padding: {
        bottom: 0,
      },
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      axisBorder: {
        show: false,
        color: "#78909C",
        height: 1,
        width: "100%",
        offsetX: 0,
        offsetY: 0,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        format: "yyyy",
        offsetY: 3,
        style: {
          colors: "#fff",
          fontSize: "18px",
          fontFamily: "Toyota Type, sans-serif",
          fontWeight: 500,
          cssClass: "apexcharts-xaxis-label",
        },
      },
      lines: {
        show: true,
      },
      type: "datetime",
    },
    legend: {
      show: false,
    },
    yaxis: {
      show: false,
      labels: {
        style: {
          fontSize: "18px",
          fontFamily: "Toyota Type, sans-serif",
          fontWeight: 500,
        },
      },
      lines: {
        show: false,
      },
    },
  };

  series: any[] = [
    {
      name: "Actual",
      data: [
        { x: new Date("2021-04-01"), y: 43298 },
        { x: new Date("2021-06-17"), y: 42327 },
      ],
    },
    {
      name: "Estimated",
      data: [
        { x: new Date("2020-10-01"), y: null },
        { x: new Date("2021-04-01"), y: 43298 },
        { x: new Date("2022-04-01"), y: 36212 },
        { x: new Date("2023-04-01"), y: 29989 },
        { x: new Date("2024-04-01"), y: 23112 },
        { x: new Date("2025-04-01"), y: 17419 },
        { x: new Date("2026-04-01"), y: 14172 },
        { x: new Date("2026-10-01"), y: null },
      ],
    },
  ];

  formatCurrency(val: number | null, _opts: any): string | undefined {
    if (val === null) {
      return undefined;
    }
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    }).format(val);
  }

  get chartStyle() {
    return `background: linear-gradient(0deg, "#fff", "#ff0000");`;
  }
}
